import { observable, computed, action, reaction } from 'mobx'
import { User, IUser } from '../Model/User'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import ActionsLocalService from '../Services/ActionsLocalService'
import { ExportType } from './ExportStore'
import { createStub } from '../Model/UsersTableItem'

export default class UsersStore {

    private static _instance: UsersStore

    private constructor() {
        this.list = []

        reaction(
            () => this.list,
            _ => {
                let data = createStub(this.list)
                ActionsLocalService.getInstance().setExportData(ExportType.Users, data)
            }
        )
    }

    public static getInstance(): UsersStore {
        return this._instance || (this._instance = new this())
    }

    @observable
    list: Array<any>

    @observable
    private item: User

    @action.bound
    setItem(u: User) {
        this.item = u
    }

    @computed
    get getItem(): IUser {
        return this.item
    }

    @computed
    get getList() {
        return this.list
    }

    setList(list: Array<any>) {
        this.list = list
    }

    updateUserFormDataToShow(data: User): User {
        if (!!data['id']) {
            let roles = []
            for(let i = 0; i < data['roles'].length; ++i) {
                roles.push(data['roles'][i]['roleName'])
            }
            data['roles'] = roles

            data['activeDateTime'] = DateTimeHelper.formatDateTimeForList(data['activeDateTime'])
            data['lastLoginDateTime'] = DateTimeHelper.formatDateTimeForList(data['lastLoginDateTime'])
            data['registrationDateTime'] = DateTimeHelper.formatDateTimeForList(data['registrationDateTime'])
        }
        
        return data
    }

    updateUserFormDataToSubmit(data: any): Object {
        let rolesToSubmit = []
        for(let i = 0; i < data['user']['roles'].length; ++i) {
            rolesToSubmit.push(
                {
                    'roleName': data['user']['roles'][i]
                }
            )
        }
        data['user']['roles'] = rolesToSubmit

        delete data['user']['activeDateTime']
        delete data['user']['lastLoginDateTime']
        delete data['user']['registrationDateTime']
        
        return data
    }

    createUserFormDataToSubmit(data: any): Object {
        return data['user']
    }

    generateRandomPassword(): string {
        return Math.random().toString(36).slice(2)
    }

    resetUser() {
        this.item = new User()
    }

    add() {
        return
    }

    remove() {
        return
    }

    update() {
        return
    }

    get(id: string) {
        return this
    }

    toggleItemIsActive(isActive: boolean) {
        this.item.isActive = isActive
    }

    toggleItemIsLockoutEnabled(lockoutEnabled: boolean) {
        this.item.lockoutEnabled = lockoutEnabled
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/UsersStore.tsx